<template>
  <p
    class="m-0"
    :class="[getColor, getClass, getTextAlign]"
    >
    <slot v-if="!text" />
    {{ text }}
  </p>
</template>

<script>
import commonProps from '@/mixins/commonProps';

// Valid variants
const variantProps = [
  'body',
  'body-light',
  'body-bold',
  'body-sm-plain',
  'body-sm',
  'body-sm-tight',
  'body-sm-bold',
  'body-sm-bold',
  'body-code-xs',
  'body-code-sm-bold',
  'body-code-sm',
  'body-sm-black',
  'body-xs',
  'body-code-xxxs-bold',
  'body-3xl',
  'body-5xl',
];


const alignProps = [
  'left', //
  'center',
  'right',
];

export default {
  mixins: [commonProps],
  props: {
    variant: {
      type: String,
      required: false,
      default: 'body',
      validator: value => variantProps.includes(value),
    },
    color: {
      type: String,
      required: false,
      default: 'text-gray-800',
      validator: value => commonProps.methods.colorProps().includes(value),
    },
    align: {
      type: String,
      required: false,
      default: null,
      validator: value => alignProps.includes(value),
    },
  },
  computed: {
    getTextAlign() {
      return [
        // Left alignment is default, declared here only to override if needed
        this.align === 'left' ? 'text-left' : null,
        this.align === 'center' ? 'text-center' : null,
        this.align === 'right' ? 'text-right' : null,
      ];
    },
    getClass() {
      return [
        this.variant === 'body-3xl' ? 'font-code text-3xl font-bold' : null,
        this.variant === 'body-5xl' ? 'font-sans text-5xl font-medium' : null,
        this.variant === 'body-lg' ? 'font-sans text-lg font-medium leading-6' : null,
        this.variant === 'body-lg-bold' ? 'font-sans  text-lg font-bold leading-6' : null,
        this.variant === 'body' ? 'font-sans  text-base font-medium leading-6' : null,
        this.variant === 'body-bold' ? 'font-sans  font-bold leading-6' : null,
        this.variant === 'body-light' ? 'font-sans font-light leading-6' : null,
        this.variant === 'body-sm-plain' ? 'font-sans  text-sm leading-6' : null,
        this.variant === 'body-sm' ? 'font-sans text-sm font-medium leading-6' : null,
        this.variant === 'body-sm-tight' ? 'font-sans text-sm font-medium leading-5' : null,
        this.variant === 'body-sm-bold' ? 'font-sans text-sm font-bold leading-6' : null,
        this.variant === 'body-code-xs' ? 'font-code text-xs leading-4' : null,
        this.variant === 'body-code-sm-bold' ? 'font-code text-sm font-bold leading-6' : null,
        this.variant === 'body-code-sm' ? 'font-code text-sm leading-6' : null,
        this.variant === 'body-sm-black' ? 'font-sans text-sm font-black leading-6' : null,
        this.variant === 'body-xs' ? 'font-sans text-xs font-medium leading-6' : null,
        this.variant === 'body-xs-semibold' ? 'font-sans text-xs font-semibold leading-6' : null,
        this.variant === 'body-code-xxxs-bold' ? 'font-code text-xxxs font-bold leading-6' : null,
      ];
    },
    getColor() {
      return [
        this.color ? this.color : null,
      ];
    },
  },
};
</script>
